import gql from 'graphql-tag'
import GqlClient from '../lib/GqlClient'
import Session from './Session'
import Logger from '@/lib/Logger'

class User {
  static attributeNames() {
    return ['id', 'firstName', 'lastName', 'email', 'termsAccepted', 'mailinglistAccepted']
  }

  static isLogged() {
    return GqlClient.isLogged()
  }

  static getClean(dirtyObj) {
    Logger.debug('dirtyObj', dirtyObj)
    let cleanObject = {}
    this.attributeNames().forEach(attrname => {
      if (attrname in dirtyObj) {
        cleanObject[attrname] = dirtyObj[attrname]
      }
    })
    Logger.debug('cleanObject:', cleanObject)
    return cleanObject
  }

  static find({ get, by, onChange, onError }) {
    Logger.debug('User.find', get)
    if (!by.id) {
      throw new Error('Called User.find with void "by.id"')
    }
    try {
      return GqlClient.activeQuery({
        retrieveGql: {
          dataKey: 'userGet',
          query: gql`
          query($userId: ID!) {
              userGet (userId: $userId)
              ${get}
          }`,
          variables: {
            userId: by.id,
          },
        },
        listenGql: {
          dataKey: 'userChanged',
          query: gql`
          subscription {
            userChanged (userId: ${by.id}) {
              id
            }
          }`,
        },
        onDataChange: data => {
          Logger.debug('New User DATA:', get, by, data)
          onChange(data)
        },
        onError: error => onError(error),
      })
    } catch (e) {
      Logger.debug(e)
    }
  }

  static async doLogin(email, password) {
    /// /
    const result = await GqlClient.runMutation({
      mutation: gql`
        mutation($input: LoginInput!) {
          userLogin(input: $input) {
            id
            email
            crc
            token
            sessionJson
          }
        }
      `,
      variables: {
        input: {
          email,
          password,
        },
      },
    })

    // const result = { data: {} };
    const user = result.data.userLogin
    const authObject = { user: user.crc, token: user.token }
    GqlClient.initAuthentication(authObject)
    localStorage.setItem('sharylist_user', JSON.stringify(user))
    // Logger.debug('xxxx', result)
    Session.restore(user.sessionJson)
    return user
  }

  static doLogout() {
    localStorage.removeItem('sharylist_user')
    GqlClient.resetAuthentication()
  }

  static register(newUser, extraData) {
    Logger.debug('Registering new user:', newUser, extraData)
    const regData = {
      utmMedium: extraData.utm_medium,
      utmCampaign: extraData.utm_campaign,
      utmSource: extraData.utm_source,
    }

    return GqlClient.runMutation({
      dataKey: 'userRegister',
      mutation: gql`
        mutation($input: UserInput!, $regData: RegDataInput) {
          userRegister(input: $input, regData: $regData) {
            id
          }
        }
      `,
      variables: {
        input: newUser,
        regData,
      },
    })
  }

  static async passwordChange(newPassword) {
    const result = await GqlClient.runMutation({
      mutation: gql`
        mutation($newPassword: String!) {
          userPasswordChange(newPassword: $newPassword) {
            success
          }
        }
      `,
      variables: {
        newPassword,
      },
    })
    Logger.debug('User.passwordChange DONE:', result)
    if (!result.data.userPasswordChange.success) {
      throw {
        name: 'FAILED_PASSWORD_CHANGE',
        message: 'Failed password change',
      }
    }
  }

  static save(user) {
    Logger.debug('User.save', user)

    return GqlClient.runMutation({
      mutation: gql`
        mutation($input: UserInput!) {
          userChange(input: $input) {
            user {
              id
              firstName
              lastName
              email
              termsAccepted
              mailinglistAccepted
            }
          }
        }
      `,
      variables: {
        input: this.getClean(user),
      },
    })
  }
}

export default User
